import { render, staticRenderFns } from "./PageMainLogout.vue?vue&type=template&id=7998757c&"
import script from "./PageMainLogout.vue?vue&type=script&lang=js&"
export * from "./PageMainLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports